export const InfoBox = ({titulo, children}) => (
  <div style={{flex:1, minWidth:200}}>
    <div style={{fontSize:11,fontWeight:600,color:"var(--z-text-muted)",textTransform:"uppercase",letterSpacing:"0.8px",marginBottom:8,paddingBottom:4,borderBottom:"1px solid var(--z-border)"}}>{titulo}</div>
    {children}
  </div>
);

export const InfoRow = ({label, value, children}) => (
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:12,padding:"5px 0",borderBottom:"1px solid var(--z-border)"}}>
    <span style={{color:"var(--z-text-secondary)",flexShrink:0,marginRight:8}}>{label}</span>
    <span style={{fontWeight:500,textAlign:"right"}}>{children||value}</span>
  </div>
);
